// *** import {Config, CognitoIdentityCredentials} from "aws-sdk";
import {
  CognitoUserPool,
// ***  CognitoUserAttribute,
  CognitoUser
// ***  AuthenticationDetails
} from "amazon-cognito-identity-js";
import React from 'react';
// *** import { userIdFunc, handleErrorFunc } from '../App';


import TextField from 'material-ui/TextField';
import Paper from 'material-ui/Paper';
// *** import RaisedButton from 'material-ui/RaisedButton';
// *** import Dialog, {
// ***   DialogActions,
// ***   DialogContent,
// ***   DialogContentText,
// ***   DialogTitle,
// *** } from 'material-ui/Dialog';


import appConfig from '../appConfig';

/*****
Config.region = appConfig.region;
Config.credentials = new CognitoIdentityCredentials({
  IdentityPoolId: appConfig.IdentityPoolId
});
*****/

const userPool = new CognitoUserPool({
  UserPoolId: appConfig.UserPoolId,
  ClientId: appConfig.ClientId,
});



export default class RecoverView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      sent: false,
      code: "",
      password: ""
    };
  }

  handleEmailChange(e) {
    this.setState({email: e.target.value});
  }
  handleCodeChange(e) {
    this.setState({code: e.target.value});
  }
  handlePasswordChange(e) {
    this.setState({password: e.target.value});
  }

  handleRequestClose = () => {
    this.setState({ sent: false });
  };
  handlePasswordSubmit = () => {
      const _self=this;
      const email = this.state.email.trim();
      var userData = {
          Username : email,
          Pool : userPool
      };
      var cognitoUser = new CognitoUser(userData);
      cognitoUser.confirmPassword(this.state.code, this.state.password,
         {
            onFailure(err) {
                console.log("### ##error="+err)
            },
            onSuccess() {
                console.log("### ##success")
                //_self.props.history.push({pathname: '/login'});
            }
         }
      );
      _self.props.history.push({pathname: '/login'});
  }



  handleSubmit(e) {
    e.preventDefault();
    const _self=this;

    const email = this.state.email.trim();
    var userData = {
          Username : email,
          Pool : userPool
    };
    var cognitoUser = new CognitoUser(userData);

    cognitoUser.forgotPassword({
        onSuccess: function (data) {
          // successfully initiated reset password request
	      console.log('CodeDeliveryData from forgotPassword: ' + data);
        },
        onFailure: function(err) {
            alert(err);
        },
        //Optional automatic callback
        inputVerificationCode: function(data) {
/*************
            console.log('Code sent to: ' + data);
            var verificationCode = prompt('Please input verification code ' ,'');
            var newPassword = prompt('Enter new password ' ,'');
            cognitoUser.confirmPassword(verificationCode, newPassword, this);
**************/

            _self.setState({ sent: true });
        }
    });
  }


  render () {
    const style = {
      width: '80%',
      margin: 50,
      padding: 50,
      display: 'inline-block',
    };

    let myform = "";
    if(!this.state.sent) {
        myform = (
          <form onSubmit={this.handleSubmit.bind(this)}>
          <h2 style={{textAlign: 'left'}}>パスワード再発行</h2>
          <p style={{textAlign: 'left'}}>登録済みメールアドレスを入力して送信ボタンを押すと、検証コードをお送りします。</p>
            <TextField fullWidth={true}
                 value={this.state.email}
                 hintText="Email"
                 onChange={this.handleEmailChange.bind(this)}/><br />
            <input type="submit"/>
          </form>
        )
    } else {
        myform = (
          <form onSubmit={this.handlePasswordSubmit}>
            <p>検証コードをメールで送りました。新パスワードを設定してください。</p>
            <TextField  fullWidth={true}
                value={this.state.code}
                hintText="検証コード"
                onChange={this.handleCodeChange.bind(this)}/>
            <TextField  fullWidth={true}
                value={this.state.password}
                hintText="新パスワード"
                onChange={this.handlePasswordChange.bind(this)}/>
            <input type="submit"/>
          </form>
        )
    }

    return (
      <div>
        <Paper style={style} zDepth={1}>
          {myform}
        </Paper>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/RecoverView.js